<template>
  <section id="faq" class="faq-section py-5">
    <div class="container">
      <h2 class="faq-title mb-4 text-center">Preguntas Frecuentes</h2>
      <div class="accordion" id="faqAccordion">
        <div class="accordion-item" v-for="(faq, idx) in faqs" :key="idx">
          <h3 class="accordion-header" :id="'heading' + idx">
            <button class="accordion-button" :class="{collapsed: activeIndex !== idx}" type="button" @click="toggle(idx)">
              {{ faq.question }}
            </button>
          </h3>
          <div :id="'collapse' + idx" class="accordion-collapse collapse" :class="{show: activeIndex === idx}">
            <div class="accordion-body">
              {{ faq.answer }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FaqSection',
  data() {
    return {
      activeIndex: null,
      faqs: [
        {
          question: '¿Medicynia cumple con la NOM-004-SSA3-2012?',
          answer: 'Sí, Medicynia está diseñado para cumplir con todos los requisitos de la NOM-004-SSA3-2012, asegurando la seguridad y legalidad de tus expedientes clínicos.'
        },
        {
          question: '¿Puedo firmar digitalmente mis notas médicas?',
          answer: 'Por supuesto. Medicynia permite la firma autógrafa digitalizada para respaldo legal en cada documento.'
        },
        {
          question: '¿Cuánto tiempo se conservan los expedientes clínicos?',
          answer: 'Los expedientes clínicos se conservan por un mínimo de 5 años, cumpliendo con la normativa mexicana.'
        },
        {
          question: '¿Puedo controlar quién accede a los expedientes?',
          answer: 'Sí, Medicynia ofrece control de acceso por usuario y bitácoras de actividad para máxima seguridad.'
        },
        {
          question: '¿Medicynia es seguro para mis pacientes?',
          answer: 'Sí, utilizamos cifrado y medidas de seguridad avanzadas para proteger la información de tus pacientes.'
        },
        {
          question: '¿Puedo seguir consultando mi información si mi plan vence?',
          answer: '¡Claro! Aunque tu plan venza, siempre podrás acceder y consultar toda tu información y expedientes. No podrás agendar nuevas citas ni modificar datos, pero nunca perderás el acceso a tu cuenta ni a tus registros.'
        },
        {
          question: '¿Las recetas y órdenes de laboratorio tienen verificación?',
          answer: 'Sí, todas nuestras recetas y órdenes de laboratorio incluyen un código QR que permite verificar que fueron expedidas por el médico correspondiente.'
        }
      ]
    }
  },
  methods: {
    toggle(idx) {
      this.activeIndex = this.activeIndex === idx ? null : idx;
    }
  }
}
</script>

<style scoped>
.faq-section {
  background: #f8f9fa;
}
.faq-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #212529;
}
.accordion {
  max-width: 800px;
  margin: 0 auto;
}
.accordion-item {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 1rem;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
}
.accordion-header {
  margin: 0;
}
.accordion-button {
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  font-size: 1.1rem;
  font-weight: 600;
  color: #00BFA5;
  padding: 1rem 1.2rem;
  border-radius: 8px 8px 0 0;
  transition: background 0.2s, color 0.2s;
}
.accordion-button.collapsed {
  color: #212529;
  background: #fff;
}
.accordion-button:not(.collapsed) {
  background: #e0fcf7;
  color: #009e7a;
  box-shadow: none;
}
.accordion-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px #1DE9B6;
}
.accordion-collapse {
  transition: max-height 0.3s ease;
}
.accordion-body {
  padding: 1rem 1.2rem;
  color: #333;
  background: #f9f9f9;
  border-radius: 0 0 8px 8px;
}
</style>
